<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            System Configurations
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            :loading="systemConfigurationListLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.name }}</td>
                <td class="justify-end layout pl-0 pr-2 py-2">
                  <v-tooltip bottom color="accent" v-if="$auth.user().AuthScope.includes('system:manage')">
                    <v-icon
                      class="mr-2"
                      color="accent"
                      slot="activator"
                      @click="$router.push(`/system-configurations/${props.item.id}/edit`)"
                    >
                      edit
                    </v-icon>
                    <span>Edit Item</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {text: 'ID', sortable: true, value: 'id'},
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      items: [],
      dialog: false,
      itemToDelete: {},
      deleteLoading: false,
      systemConfigurationListLoading: false,
      pagination: {
        sortBy: 'id'
      }
    }
  },
  created () {
    this.systemConfigurationListLoading = true
    this.fetchSystemConfigurations()
  },
  methods: {
    fetchSystemConfigurations () {
      this.axios.get('/system-configurations')
        .then(response => {
          response.data.forEach(systemConfiguration => {
            this.items.push({
              id: systemConfiguration.id,
              config: systemConfiguration.config,
              name: systemConfiguration.name
            })
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.systemConfigurationListLoading = false
        })
    }
  }
}
</script>

<style>

</style>
